import React from 'react';

import {
	Card, ImgWrapper, OTCCard, OTCCardCard, Text, Wrapper
} from './styles';

const PaypalUI = (props) =>
{
	let newStyle = {};
	if (props.medCheckout || props.useUpdatedRegistration) {
		newStyle = {
			border: '1px solid #d9d9d9',
			borderRadius: '2px',
		}
	}
	if (props.otcCheckout) {
		return (
			<Wrapper>
				<OTCCardCard>
          Card
				</OTCCardCard>
				<OTCCard
					onClick={props.open}
					darkMode={props.darkMode}
				>
					<ImgWrapper>
						<img
							src="https://www.paypalobjects.com/webstatic/mktg/Logo/pp-logo-200px.png"
							border="0"
							alt="PayPal Logo"
						/>
					</ImgWrapper>
				</OTCCard>
			</Wrapper>
		);
	}
	return (
		<Card
			style={newStyle}
			onClick={props.open}
			darkMode={props.darkMode}
		>
			<Text>
        Pay with
			</Text>
			<ImgWrapper>
				<img
					src="https://www.paypalobjects.com/webstatic/mktg/Logo/pp-logo-200px.png"
					border="0"
					alt="PayPal Logo"
				/>
			</ImgWrapper>
		</Card>
	);
};

export default PaypalUI
